import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";

export interface ProposalAnalyticsFilters {
  order_id: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface ProposalAnalyticsSelectedFilters {
  order_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface ProposalAnalyticsAPIFilters {
  order_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForProposalAnalyticsFilters(
  params: ProposalAnalyticsFilters | null,
  query_params: URLSearchParams
): ProposalAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");
  return {
    order_id: params?.order_id ?? [],

    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
